import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducer from './rootReducer';

let store = createStore(
  reducer,
  applyMiddleware(thunkMiddleware)
  // works with devtools
  // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;



// WEBPACK FOOTER //
// ./src/reducers/store.js